// Vue 3 警告处理器 - 客户端
export default defineNuxtPlugin(() => {
  if (process.env.NODE_ENV !== 'development') {
    return
  }

  // 检查是否启用静音模式
  const isQuietMode = process.env.DEV_QUIET === 'true' || process.env.SUPPRESS_WARNINGS === 'true'
  
  if (!isQuietMode) {
    return
  }

  // Vue 3 警告过滤模式
  const VUE_WARNING_FILTERS = [
    'inject() can only be used inside setup()',
    'injection "loginModal" not found',
    'injection "CompleteInfo" not found',
    'Missing required prop',
    'Invalid prop',
    'Unknown custom element',
    'runtime-core.esm-bundler.js',
    'runtime-dom.esm-bundler.js',
    'No match found for location'
  ]

  // 如果是客户端环境
  if (typeof window !== 'undefined') {
    const { vueApp } = useNuxtApp()
    
    // 设置 Vue 全局警告处理器
    if (vueApp && vueApp.config) {
      // 保存原始的警告处理器
      const originalWarnHandler = vueApp.config.warnHandler
      
      // 自定义警告处理器
      vueApp.config.warnHandler = (msg, instance, trace) => {
        // 检查是否应该过滤这个警告
        const shouldFilter = VUE_WARNING_FILTERS.some(filter => 
          msg.includes(filter)
        )
        
        // 如果不需要过滤，则显示警告
        if (!shouldFilter) {
          if (originalWarnHandler) {
            originalWarnHandler(msg, instance, trace)
          } else {
            console.warn(`[Vue warn]: ${msg}`, instance, trace)
          }
        }
      }
      
      // 设置全局错误处理器（可选）
      vueApp.config.errorHandler = (err, instance, info) => {
        const errorMessage = err.toString()
        const shouldFilter = VUE_WARNING_FILTERS.some(filter => 
          errorMessage.includes(filter)
        )
        
        if (!shouldFilter) {
          console.error('[Vue Error]:', err, instance, info)
        }
      }
    }
  }

  console.log('🔇 Vue 警告处理器已启用 (静音模式)')
})